module.exports = __webpack_public_path__ + "static/gestion_tierras_nf-fadb337d570e4a78fb433c1bf3e48b47.png";